"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumnWidth = exports.getAllColumnWidths = void 0;
var widths = {
  Full: 12,
  'Three Quarter': 9,
  Half: 6,
  Third: 4,
  'Two Third': 8,
  Quarter: 3,
  Sixth: 2
};
var getAllColumnWidths = function getAllColumnWidths(field) {
  return {
    xs: field.mobileWidth ? getColumnWidth(field, 'xs') : 12,
    sm: getColumnWidth(field, 'sm'),
    md: getColumnWidth(field, 'md'),
    lg: getColumnWidth(field, 'lg')
  };
};
exports.getAllColumnWidths = getAllColumnWidths;
var getColumnWidth = function getColumnWidth(_ref, breakpoint) {
  var type = _ref.type,
    width = _ref.width,
    mobileWidth = _ref.mobileWidth;
  if (type === 'spacer' || type === 'title' || type === 'alert') {
    return widths['Full'];
  }
  if (mobileWidth && ['xs'].includes(breakpoint)) {
    return widths[mobileWidth];
  }
  if (width === 'Quarter' && breakpoint !== 'lg' && !mobileWidth) {
    return widths['Full'];
  }
  if (width === 'Sixth' && breakpoint !== 'lg' && !mobileWidth) {
    return widths['Third'];
  }
  return widths[width];
};
exports.getColumnWidth = getColumnWidth;